import React from "react";
import PlacesAutocomplete, {
  geocodeByAddress,
  geocodeByPlaceId,
  getLatLng
} from "react-places-autocomplete";
import FontAwesome from "react-fontawesome";
import logger from "../../../utils/LoggerFrontend";
import "./location-select.css";
import SelectedLocationItem from "./LocationSelector__Item.jsx";
import MapComponent from "./GoogleMap.jsx";
import { t } from "i18next";
import { withTranslation } from "react-i18next";
import loadGoogleMaps from "../../../utils/LoadGoogleMapsScript.js";

const DEFAULT_RADIUS_CITY = 20; // in kilometers
const DEFAULT_RADIUS_STATE = 80; // in kilometers
const LIST_OF_ORGAS = ["-Kr5CZlS7jHaD5WfLalL", "-Ksc_MlxAS_7HBXUTsIg", "RJSW1IVKfobPqGBsYxW0"];
const CITY_STATES = ["Bremen", "Berlin", "Hamburg"];
const AREA_TYPE = "administrative_area_level_1";
const TYPE_CITY = "city";
const TYPE_STATE = "state";
const TYPE_COUNTRY = "country";

class CampaignCreateLocationSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      address: "",
      location: props.location || [],
      togglMapView: false,
      selectedCountry: false,
      duplicate: false,
      isRemoteJob: false,
      searchOptions: null,
      mapsLoaded: false
    };
  }

  componentDidMount() {
    const language = window.language || "de";
    loadGoogleMaps(language)
      .then((google) => {
        const searchOptions = {
          location: new google.maps.LatLng(51.1657, 11.7764),
          radius: 500000,
          types: ["(regions)"]
        };
        this.setState({ searchOptions, mapsLoaded: true });
      })
      .catch((err) => {
        console.error("Google Maps failed to load", err);
      });
  }

  handleChange = (address) => {
    this.setState({
      address,
      duplicate: false,
      selectedCountry: false
    });
  };

  clearErrors = () => {
    this.setState({
      duplicate: false,
      selectedCountry: false
    });
  };

  handleChangeRadius = (radius, index) => {
    const { location } = this.state;
    const locs = [...location];
    locs[index] = { ...locs[index], radius };

    this.setState({
      location: locs
    });
    if (this.props.onSelect) {
      this.props.onSelect(locs);
    }
  };

  // Handle removing selected location
  handleRemove = (index) => {
    const { location } = this.state;
    const locs = [...location];
    locs.splice(index, 1);

    this.setState({
      location: locs
    });

    if (this.props.onSelect) {
      this.props.onSelect(locs);
      return;
    }
  };

  // helper for handling selecting location
  async handleSelectHelper(addr, placeId, suggestion) {
    if (!suggestion) {
      return -1;
    }
    const { location } = this.state;
    const {
      formattedSuggestion: { mainText },
      types
    } = suggestion;

    // TODO: make everything use the placeId (unless I'm missing something)
    // The placeId is way more accurate than addr and they return the same object (if they are the same)
    // Otherwise it can happen that by small alterations in addr, the place is completely different
    const resultOfPlaceId = await geocodeByPlaceId(placeId);
    // get the search result from API if it couldn't find it from the placeId
    const results = resultOfPlaceId || (await geocodeByAddress(addr));
    const { lat, lng } = await getLatLng(results[0]);

    const locClass = resultOfPlaceId[0].address_components;

    logger.log("CampaignCreateLocationSelector:handleSelect", "request result", resultOfPlaceId);

    //
    // get the data from the API call result and construct new location Object
    //

    // determine if the location is city, state, or country
    let areaType =
      types.includes(AREA_TYPE) || CITY_STATES.includes(mainText) ? TYPE_STATE : TYPE_CITY;

    let stateOfLoc, country, twoLetterCountry;
    stateOfLoc = "";

    // determine state and country of the location
    locClass.forEach((elem) => {
      if (elem.types.includes(AREA_TYPE)) {
        stateOfLoc = elem.long_name;
      } else if (elem.types.includes(TYPE_COUNTRY)) {
        country = elem.long_name;
        twoLetterCountry = elem.short_name;
      }
    });
    let { long_name: locName } = locClass[0];
    areaType = country === locName ? TYPE_COUNTRY : areaType;

    //if zip code is the search term, set city name and not the zip code as the location label
    // TODO: duplicated code on the backend
    if (locClass[0].types.includes("postal_code")) {
      const searchLabel = resultOfPlaceId[0].formatted_address;
      const locality = locClass.find(
        // We skip index 0 because it would match the postal code
        //? Is it necessary to match with lowercases and without accents??
        (c, index) => index !== 0 && searchLabel.includes(c.long_name)
      );

      // Since the zip code is being entered we don't know just by the search term if it the user wants a locality, sublocality, etc. so let's try to match it
      if (locality) {
        locName = locality.long_name;
      } else {
        // Otherwise set the first match, which would be the smallest one, as for instance, a sublocality (test with: 90402)
        locName = locClass[1].long_name;
      }
    }

    const locObject = {
      location: locName,
      stateOfLoc,
      country,
      twoLetterCountry,
      type: areaType,
      radius: areaType === TYPE_STATE ? DEFAULT_RADIUS_STATE : DEFAULT_RADIUS_CITY,
      lat,
      lng,
      placeIdResults: locClass,
      //city, state, and country for integrating with the old keys
      extra: country,
      label: locName,
      region: stateOfLoc
    };

    const joinedLoc = location.concat(locObject);

    logger.log("LocationSelector:HandleSelect", "all locations with selected location", {
      joinedLoc
    });

    this.setState({
      address: "",
      location: joinedLoc
    });

    // if there is onSelect function passed from props call that and return
    if (this.props.onSelect) {
      this.props.onSelect(joinedLoc, locObject);
      return;
    }
  }

  //handle selecting location
  async handleSelect(addr, placeId, suggestion) {
    if (!suggestion) {
      return -1;
    }
    const { location } = this.state;
    const {
      formattedSuggestion: { secondaryText }
    } = suggestion;

    let includesDuplicate = false;

    const resultOfPlaceId = await geocodeByPlaceId(placeId);
    logger.debug("LocationSelect:handleSelect", "resultOfPlaceId", resultOfPlaceId);

    const locClass = resultOfPlaceId[0].address_components;
    //count selected states and check if we are adding duplicate
    for (let i = 0; i < location.length; i++) {
      if (locClass[0]) {
        if (location[i].location === locClass[0].long_name) {
          includesDuplicate = true;
        }
      }
    }
    //check if addr is defined, isn"t duplicate and isn"t whole country
    if (!secondaryText && !includesDuplicate) {
      if (this.props.allowCountrySelection) {
        this.handleSelectHelper(addr, placeId, suggestion);
      } else {
        this.setState({
          address: "",
          selectedCountry: true
        });
      }
    } else if (includesDuplicate) {
      this.setState({
        address: "",
        duplicate: true
      });
    } else if (addr && !includesDuplicate && secondaryText) {
      this.handleSelectHelper(addr, placeId, suggestion);
    }
  }

  handleMapClick = () => {
    this.setState({
      togglMapView: !this.state.togglMapView
    });
  };

  renderMap() {
    if (this.state.togglMapView) {
      return (
        <div className="location-select__map-component">
          <MapComponent locations={this.state.location} />
        </div>
      );
    }
  }

  renderToggleMapIcon() {
    const name = this.state.togglMapView ? "toggle-on" : "toggle-off";
    return (
      <div className="location-select__show-map-icon" onClick={this.handleMapClick}>
        <FontAwesome name={name} />
        <div className="location-select__show-map-label">{t("Map")}</div>
      </div>
    );
  }

  onSelect = (addr, placeId, suggestion) => {
    this.handleSelect(addr, placeId, suggestion);
    logger.log("CampaignCreateLocationSelector:onSelect", "location object", suggestion);
  };

  handleRemoteJob = () => {
    const isRemoteJob = !this.state.isRemoteJob;
    this.setState({ isRemoteJob: isRemoteJob });
    this.props.onChangeRemote(isRemoteJob);
  };

  render() {
    const { orgaId = "", t } = this.props;
    const {
      location = [],
      address,
      selectedCountry,
      duplicate,
      mapsLoaded,
      searchOptions
    } = this.state;
    const errorMessage = selectedCountry
      ? t("*Selecting an entire country is not possible. Select a city or state.")
      : duplicate
      ? t("*This location has already been selected. Try another one.")
      : " ";

    if (!mapsLoaded || !searchOptions) return null;

    return (
      <div>
        <div className="location-select__wrapper">
          <div className="location-select__wrapper-components">
            <PlacesAutocomplete
              highlightFirstSuggestion
              value={address}
              onSelect={this.onSelect}
              onChange={this.handleChange}
              debounce={400}
              shouldFetchSuggestions={true}
              searchOptions={searchOptions}
            >
              {/* DO NOT move out(Specific Syntax Because of Places AutoComplete Library) */}
              {/* render location input field and suggestions' dropdown */}
              {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => {
                const { showError } = this.props;
                const showErr = showError && this.state.location.length < 1;

                return (
                  <div className="location-select__create-campaign-area">
                    {/* Render Input Field */}
                    <div className="location-select__searchbar-area" onClick={this.clearErrors}>
                      <div className="location-select__search-icon">
                        <img src="/images/search.svg" />
                      </div>
                      <input
                        {...getInputProps({
                          placeholder: t("Enter location..."),
                          className: showErr
                            ? "location-select__location-search-error-input"
                            : "location-select__location-search-input"
                        })}
                      />
                      {this.renderToggleMapIcon()}
                      <div className="location-select__error">{errorMessage}</div>
                    </div>

                    {/* Render Suggestions' Dropdown */}
                    <div className="location-select__autocomplete-dropdown-container">
                      {loading && (
                        <div className="location-select__loading-bar">{t("Is loading...")}</div>
                      )}
                      {suggestions.map((suggestion) => {
                        return (
                          <div
                            key={suggestion.placeId}
                            {...getSuggestionItemProps(suggestion, {
                              className: "location-select__dropdown-elements"
                            })}
                          >
                            {suggestion.description}
                          </div>
                        );
                      })}
                    </div>

                    {/* Remote Job Button */}
                    {LIST_OF_ORGAS.includes(orgaId) && (
                      <span style={{ display: "flex", gap: "4px" }}>
                        <input
                          id="remote-job-check"
                          type="checkbox"
                          onClick={this.handleRemoteJob}
                        />
                        <label htmlFor="remote-job-check">{t("Remote Job")}</label>
                      </span>
                    )}

                    {/* Render Selected Locations */}
                    <div className="location-select__selected-locations">
                      {location.length > 0 &&
                        location.map((selectedloc, index) => {
                          return (
                            <SelectedLocationItem
                              key={index}
                              index={index}
                              handleChangeRadius={this.handleChangeRadius}
                              handleRemoveLoc={this.handleRemove}
                              type={selectedloc.type}
                              location={selectedloc.location || selectedloc.label}
                              radius={selectedloc.radius}
                              state={selectedloc.stateOfLoc || selectedloc.region}
                              country={selectedloc.country || selectedloc.extra}
                              twoLetterCountry={selectedloc.twoLetterCountry}
                            />
                          );
                        })}
                    </div>
                    <br></br>
                    <br></br>
                    <br></br>
                    {this.renderMap()}
                  </div>
                );
              }}
            </PlacesAutocomplete>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(CampaignCreateLocationSelector);
